module.exports = {
    'speech-rec-start.mp3': require('!arraybuffer-loader!./assets/speech-rec-start.mp3'),
    'speech-rec-end.mp3': require('!arraybuffer-loader!./assets/speech-rec-end.mp3')
};
